import calls from '@/backend/api-calls'

const state = () => ({
  drawingHighlights: [],
  selected: [],
  allSelected: false,
  loading: false,
  pagination: {
    page: 1,
    pages: 1
  },
  filters: {
    product_brand: 'Mitrex',
    project_id: null
  }
})

// getters
const getters = {
  ids: state => {
    return state.drawingHighlights.map(d => d.id);
  }
}

// actions
const actions = {
  getDrawingHighlights: ({commit}, parameters) => {
    commit("setLoading", true);

    return new Promise((resolve, reject) => {
      calls.drawingHighlights.get(parameters)
        .then(resp => {
          commit("setDrawingHighlights", resp.data);
          commit("setLoading", false);
          resolve(resp);
        }).catch(err => {
          commit("setLoading", false);
          reject(err);
        })
    })
  },
  addDrawingHighlight({commit}, data) {
    return new Promise((resolve, reject) => {
      calls.drawingHighlights.post(data)
        .then(resp => {
          commit("insertDrawingHighlight", resp.data);
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  addImage({commit}, { drawingHighlightId, data, params }) {
    return new Promise((resolve, reject) => {
      calls.drawingHighlight.addImage(drawingHighlightId, data, params)
        .then(resp => {
          commit("insertUpdatedDrawingHighlight", resp.data);
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  updateDrawingHighlight: ({commit}, { drawingHighlightId, data }) => {
    return new Promise((resolve, reject) => {
      calls.drawingHighlight.put(drawingHighlightId, data).then(
        resp => {
          commit("insertUpdatedDrawingHighlight", resp.data);
          commit("app/setNotification", {
            type: 'success',
            status: true,
            message: 'Drawing highlight successfully updated'
          }, { root: true });

          resolve(resp);
        }
      ).catch(err => reject(err));
    })
  },
  deleteDrawingHighlight: ({commit}, drawingHighlightId) => {
    return new Promise((resolve, reject) => {
      calls.drawingHighlight.delete(drawingHighlightId).then(
        resp => {
          commit("removeDrawingHighlight", drawingHighlightId);
          commit("app/setNotification", {
            type: 'success',
            status: true,
            message: 'Drawing highlight successfully deleted'
          }, { root: true });

          resolve(resp);
        }
      ).catch(err => reject(err));
    })
  },
  toggleAllSelected: ({commit, getters}, value) => {
    if (value) {
      commit("selectAll", getters.ids);
    } else {
      commit("deselectAll");
    }
  }
}

// mutations
const mutations = {
  setLoading(state, status) {
    state.loading = status;
  },
  setDrawingHighlights(state, data) {
    state.pagination = data.pagination;
    state.drawingHighlights = data.results;
  },
  insertDrawingHighlight(state, data) {
    state.drawingHighlights.push(data);
  },
  insertUpdatedDrawingHighlight(state, data) {
    state.drawingHighlights.forEach((highlight, i) => {
      if (highlight.id == data.id) {
        state.drawingHighlights.splice(i, 1, data);
      }
    })
  },
  removeDrawingHighlight(state, drawingHighlightId) {
    state.drawingHighlights.forEach((drawingHighlight, i) => {
      if (drawingHighlight.id == drawingHighlightId) {
        state.drawingHighlights.splice(i, 1);
      }
      const index = state.selected.indexOf(drawingHighlightId);
      if (index != -1) {
        state.selected.splice(index, 1);
      }
    })
  },
  setFilter(state, { field, value }) {
    state.filters[field] = value;
  },
  changePage(state, page) {
    state.pagination.page = page;
  },
  selectAll(state, ids) {
    state.allSelected = true;
    ids.forEach(id => {
      if (state.selected.indexOf(id) == -1) {
        state.selected.push(id);
      }
    })
  },
  deselectAll(state) {
    state.allSelected = false;
    state.selected.splice(0, state.selected.length)
  },
  toggleSelected(state, id) {
    const index = state.selected.indexOf(id);

    if (index == -1) {
      state.selected.push(id);
    } else {
      state.selected.splice(index, 1);
      if (state.selected.length == 0) {
        state.allSelected = false;
      }
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}